import { render, staticRenderFns } from "./termo-aceite.vue?vue&type=template&id=d62061b6&"
import script from "./termo-aceite.vue?vue&type=script&lang=ts&"
export * from "./termo-aceite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d62061b6')) {
      api.createRecord('d62061b6', component.options)
    } else {
      api.reload('d62061b6', component.options)
    }
    module.hot.accept("./termo-aceite.vue?vue&type=template&id=d62061b6&", function () {
      api.rerender('d62061b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/termo-aceite/termo-aceite.vue"
export default component.exports